import { render, staticRenderFns } from "./LeaveWasUpdated.vue?vue&type=template&id=1bb5995a"
import script from "./LeaveWasUpdated.vue?vue&type=script&lang=js"
export * from "./LeaveWasUpdated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports